import React from "react";
import { motion } from "framer-motion";

const items = [
  "Eventos Corporativos",
  "Feiras",
  "Shopping Centers",
  "Festas",
  "Casamentos",
  "Aniversários",
  "Lançamentos de Produtos",
  "Ações Promocionais",
  "Convenções",
];

export default function About({ settings }) {
  return (
    <section id="sobre" className="relative py-28 md:py-40 bg-[#090909] carbon-fiber overflow-hidden" data-testid="about-section">
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#E31B23]/10 blur-[120px]" />
      <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#008CFF]/10 blur-[120px]" />

      <div className="relative max-w-[1400px] mx-auto px-6 grid lg:grid-cols-12 gap-16 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[1px] w-10 bg-[#008CFF]" />
            <span className="overline">Sobre a SIM Experience</span>
          </div>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
            <span className="text-white">EXPERIÊNCIAS </span>
            <span className="text-transparent" style={{ WebkitTextStroke: "1px #E31B23" }}>IMERSIVAS</span>
            <br />
            <span className="text-white">PARA CADA </span>
            <span className="neon-blue">EVENTO.</span>
          </h2>
          <p className="mt-8 text-neutral-300 text-lg leading-relaxed max-w-lg">
            {settings?.about_text ||
              "A SIM EXPERIENCE leva experiências imersivas para eventos corporativos, feiras, shopping centers, festas, casamentos, aniversários, lançamentos de produtos, ações promocionais e convenções."}
          </p>
          <div className="mt-10 flex items-center gap-6">
            <div className="w-16 h-16 rounded-full border border-[#E31B23]/40 flex items-center justify-center pulse-red">
              <div className="w-3 h-3 rounded-full bg-[#E31B23]" />
            </div>
            <div className="text-sm">
              <div className="font-display font-bold text-white">Atendimento nacional</div>
              <div className="text-neutral-400">Transportamos nossa estrutura para todo o Brasil</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-3">
          {items.map((label, i) => (
            <motion.div
              key={label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="group relative aspect-[4/3] p-5 flex flex-col justify-between rounded-xl glass overflow-hidden"
              data-testid={`about-item-${i}`}
            >
              <div className="overline text-neutral-500">0{i + 1}</div>
              <div className="font-display font-bold text-lg md:text-xl leading-tight text-white">
                {label}
              </div>
              <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#E31B23] to-[#008CFF] scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
